import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { TextField } from 'material-ui';
import { loginStep } from 'actions/account/login';
import { useSSO } from 'config';
import { get, isEmpty } from 'lodash';
import ReCAPTCHA from 'react-google-recaptcha';
import { recaptchaKey } from 'utils/settings';
import pallet from 'constants/colors';
import { FormattedMessage } from 'react-intl';
import PanelMessage from 'components/panels/PanelMessage';
import KButton from '../KJRN/KButton';
import KTitle from '../KJRN/KTitle';
import { forgotPassword } from '../../actions/account/resetPassword';

const styles = {
  input: {
    marginTop: 0,
  },
  divider: {
    marginTop: 0,
  },
  cardContent: {
    paddingTop: 0,
    paddingRight: 8,
    paddingLeft: 8,
  },
  root: {
    marginTop: 12,
    marginBottom: 12,
  },
  message: {
    textAlign: 'center',
    padding: 24,
    textTransform: 'uppercase',
    fontWeight: 500,
  },
  sso: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 16,
    marginBottom: 16,
  },
  switch: {
    textAlign: 'center',
    marginTop: 32,
  },
  actions: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
  },
  containerSSO: {
    marginTop: '10vh',
    zIndex: 100,
  },
  container: {
    marginTop: '5vh',
    display: 'flex',
    flexDirection: 'row',
    maxWidth: 600,
    width: '100%',
    flexWrap: 'wrap',
    zIndex: 100,
  },
  underlineStyle: {
    borderColor: pallet.primaryColor1,
    color: pallet.primaryColor1,
  },
  titleContainer: {
    display: 'flex',
    flex: '1 1 90%',
    alignItems: 'flex-start',
    flexDirection: 'column',
    paddingTop: 10,
  },
  inputContainer: {
    display: 'flex',
    flexDirection: 'column',
    width: 'calc(100% - 24px)',
    padding: 12,
  },
  backContainer: {
    flex: 1,
  },
};
const ForgotPassword = ({ sendRequest, goBack }) => {
  const [recaptchaToken, setRecaptchaToken] = useState('');
  const [username, setUsername] = useState('');
  const [validationError, setValidationError] = useState(false);
  const recaptchaRef = React.createRef();
  const onSubmit = () => {
    if (isEmpty(username) || isEmpty(recaptchaToken)) {
      setValidationError(true);
    } else {
      sendRequest({ Username: username, Recaptcha: recaptchaToken });
      goBack();
    }
  };
  return (
    <div style={styles.container}>
      <div style={styles.titleContainer}>
        <KButton
          flat
          buttonStyle={{ fontSize: 14 }}
          containerStyle={{ height: 32, width: 150, alignSelf: 'flex-end' }}
          label={<FormattedMessage id="back" />}
          onClick={goBack}
        />
        <KTitle title={<FormattedMessage id="account.forgotPassword" />} />
        <div style={styles.inputContainer}>
          <TextField
            type="text"
            hintText={<FormattedMessage id="account.usernameemail" />}
            style={styles.root}
            inputStyle={styles.input}
            underlineFocusStyle={styles.underlineStyle}
            autoComplete="off"
            autoCorrect="off"
            onChange={e => setUsername(get(e, 'target.value'))}
            autoCapitalize="off"
            spellCheck="false"
            fullWidth
            id="username"
          />
          <ReCAPTCHA
            sitekey={recaptchaKey}
            onChange={val => setRecaptchaToken(val)}
            ref={recaptchaRef}
          />
          <KButton
            label={<FormattedMessage id="submit" />}
            containerStyle={{ width: 200, alignSelf: 'center', marginTop: '5vh' }}
            onClick={onSubmit}
          />
          {validationError &&
              (<PanelMessage
                message={<FormattedMessage id="forgotPassword.validationError" />}
                iconName="warning"
                type="warning"
              />)
            }
        </div>
      </div>
    </div>
  );
};

ForgotPassword.propTypes = {
  sendRequest: PropTypes.func,
  goBack: PropTypes.func,
};

export default connect(
  ({ languageReducer }) => ({ ...languageReducer }),
  dispatch => ({
    goBack: () => dispatch(loginStep(useSSO ? 'sso' : 'initial')),
    sendRequest: data => dispatch(forgotPassword(data)),
  }),
)(ForgotPassword);



// WEBPACK FOOTER //
// ./src/components/account/ForgotPassword.js